var Collaborator = /** @class */ (function () {
    function Collaborator(props) {
        this.services = [];
        this.packets = [];
        Object.assign(this, props);
        if (props.client) {
            this.address = props.client.address;
            this.businessName = props.client.businessName;
            this.city = props.client.city;
            this.email = props.client.email;
            this.name = props.client.name;
            this.phone = props.phone;
            this.province = props.client.province;
            this.tin = props.client.tin;
            this.tradename = props.client.tradename;
            this.zip = props.client.zip;
        }
        delete this.client;
        if (props && props.disabled_at) {
            this.status = 'disabled';
            this.disabled_at = new Date(props.disabled_at);
        }
        else if (props) {
            this.status = 'enabled';
        }
    }
    return Collaborator;
}());
export default Collaborator;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/Model.ts
// module id = 714
// module chunks = 0